import React from 'react';
import styled from '@emotion/styled';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { ACCESS_CODE } from '../../../constants/define/translation';
import { OptionSearchAccessCode } from '../../pages/misc/AccessCode';
import { FILTER_DURATION, FILTER_PLAN, FILTER_STATUS } from '../../../constants/access-code/accessCodeConstants';
import { AccessCodeStatus } from '../../../types/accessCode';
import { appStyles } from '../../../styles';
import { SelectOption } from '../../atoms';

interface AccessCodeFilterProps {
  options?: OptionSearchAccessCode;
  getFilteredData: (data: any) => void;
}

export const AccessCodeFilter = (props: AccessCodeFilterProps) => {
  const { t } = useTranslation(ACCESS_CODE);
  const { options, getFilteredData } = props;
  return (
    <StyledRowFilter>
      <Col span={4} className="full-width">
        <span className="text">{t('form.status')}: </span>
        <SelectOption
          defaultValue={AccessCodeStatus.ALL}
          onChange={e => {
            getFilteredData({
              status: e,
            });
          }}
          values={FILTER_STATUS}
          textDisplay="text"
        />
      </Col>
      <Col offset={1} span={4} className="full-width">
        <span className="text">Plan: </span>
        <SelectOption
          defaultValue={options?.plan}
          onChange={e => {
            getFilteredData({
              plan: e,
            });
          }}
          values={FILTER_PLAN}
          textDisplay="text"
        />
      </Col>
      <Col offset={1} span={4} className="full-width">
        <span className="text">Duration: </span>
        <SelectOption
          defaultValue={options?.duration}
          onChange={e => {
            getFilteredData({
              duration: e,
            });
          }}
          values={FILTER_DURATION}
          textDisplay="text"
        />
      </Col>
      <Col offset={4} span={6}>
        <StyledSearchInput
          onChange={e => {
            getFilteredData({
              strSearch: e.target.value,
            });
          }}
          value={options?.strSearch}
          placeholder={t('filter.searchPlaceholder')}
          suffix={
            !options?.strSearch ? (
              <SearchOutlined />
            ) : (
              <CloseOutlined
                onClick={() => {
                  getFilteredData({
                    strSearch: '',
                  });
                }}
              />
            )
          }
        />
      </Col>
    </StyledRowFilter>
  );
};

const StyledRowFilter = styled(Row)`
  padding: 0.5rem 0 0.75rem;
  & .full-width {
    & .ant-select {
      width: 180px;
      max-width: 180px;
      min-width: 120px;
    }
  }

  & .ant-col {
    display: flex;
    & .text {
      font-weight: bold;
      font-size: 14px;
      line-height: 34px;
    }
    & .ant-select-selector {
      margin-left: 0.5rem;
    }
  }
`;

const StyledSearchInput = styled(Input)`
  ${appStyles.searchInput}
`;
